var _path, _path2, _g, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBagSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M50 0c-27.614 0-50 22.387-50 50 0 27.615 22.386 50 50 50 27.613 0 50-22.385 50-50 0-27.613-22.387-50-50-50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D07C40",
    d: "M19.004 29.985h62.021v49.976h-61.959l-.062-49.976z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EFC75E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.003 42.015c0 .025-67.944-.02-68.008 0v37.919c.001.004-.007 2.999-.018 6.693 8.925 8.293 20.878 13.373 34.023 13.373 13.122 0 25.057-5.061 33.977-13.328-.031-3.709-.057-6.723-.055-6.724 0-15.728.081-37.933.081-37.933zM75.021 34.009v6.521l6.004-1.17v-9.375zM25.01 40.023v-6.014l-6.006-4.024v9.984z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBA250",
    d: "M25.01 42.015v-8.006l-9.015 8.006h9.015zm50.011-8.006v8.006h8.981l-8.981-8.006z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBA950",
    d: "M71.064 57.558c0-.838-.724-1.586-1.562-1.586s-1.649.748-1.649 1.586c-.004 10.158-7.641 18.393-17.8 18.393-10.16 0-17.996-8.233-18.001-18.393 0-.838-.71-1.586-1.549-1.586s-1.657.748-1.657 1.586c0 11.936 9.275 21.608 21.209 21.608 11.933 0 21.009-9.674 21.009-21.608z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D07C40",
    d: "M30.472 52.988c-1.37 0-2.48 1.11-2.48 2.48 0 1.369 1.11 2.479 2.48 2.479 1.37 0 2.512-1.11 2.512-2.479-.001-1.368-1.143-2.48-2.512-2.48zm39.001 0c-1.371 0-2.48 1.11-2.48 2.48 0 1.369 1.109 2.479 2.48 2.479 1.369 0 2.512-1.11 2.512-2.479-.003-1.368-1.144-2.48-2.512-2.48z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M71.064 56.558c0-.838-.724-1.586-1.562-1.586s-1.649.748-1.649 1.586c-.004 10.158-7.641 18.393-17.8 18.393-10.16 0-17.996-8.233-18.001-18.393 0-.838-.71-1.586-1.549-1.586s-1.657.748-1.657 1.586c0 11.936 9.275 21.608 21.209 21.608 11.933 0 21.009-9.674 21.009-21.608z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagSvgrepoCom);
export default __webpack_public_path__ + "static/media/shopping-bag-svgrepo-com.e7abf729795379558aa4ee9b21e803cd.svg";
export { ForwardRef as ReactComponent };